








































































































































































































































































































import { Individu } from "@/models/Individu";
import { Pointage } from "@/models/Pointage";
import { TarifEventSchedulerActiviteDocument } from "@/models/TarifEventSchedulerActiviteDocument";
import { utils } from "@/util";
import { Vue } from "vue-property-decorator";

import AppIcon from "@/components/app-icon.vue";
import { Autorisations } from "@/models/Autorisations";
import { PaletteDocument } from "@/models/PaletteDocument";
import { Supplement } from "@/models/Supplement";
import { TarifActiviteDocument } from "@/models/TarifActiviteDocument";
import cell from "./cell.vue";

export default Vue.extend({
  components: {cell, AppIcon },
  props: {
    listenfants: {
      type: Array,
      default: () => [],
    },
    listSeancesTempsAccueil: {
      type: Array,
      default: () => [],
    },
    pointageActif: {
      type: Array,
      default: () => [],
    },
    alphabet: {
      type: String,
    },
    pointagePrevi: {
      type: Array,
      default: () => [],
    },
    palettepresence: {
      type: Array,
      default: () => [],
    },
    paletteabsence: {
      type: Array,
      default: () => [],
    },
    listSeanceSupplement: {
      type: Array,
      default: () => [],
    },
    pointagesSupplements: {
      type: Array,
      default: () => [],
    },
    listSupplementsPrevi: {
      type: Array,
      default: () => [],
    },
    currentDate: {
      type: String,
      default: () => "-1",
    },
    currentActiviteID: {
      type: Number,
    },
    filtreAutori: {
      type: Number,
      default: -2,
    },
    nbrIndividusPresents: {
      type: Number,
      default: () => 0,
    },
    nbrIndividusFiltreesPresents: {
      type: Number,
      default: () => 0,
    },
    currentEtablissement: {
      type: Object,
    },
    nbrIndividusTotal: {
      type: Number,
      default: 999,
    },
  },
  data() {
    return {
      listActif: [] as Array<String>,
      listindividus: [] as Array<Individu>,
      now: utils.getCurrentTimeNow().format("YYYYMMDD"),
      listPalette: [] as Array<PaletteDocument>,
      listSuppActifs: [] as Array<String>,
    };
  },
  mounted() {
    this.now = utils
      .getDateFromString(this.currentDate, "YYYY-MM-DD")
      .format("YYYYMMDD");

    this.listActif = Array.from(
      this.pointageActif.map((pointage: any) => pointage.get_id())
    );
    this.listSuppActifs = this.pointagesSupplements.map((supplement: any) =>
      supplement.get_id()
    );
    this.listindividus = this.listenfants.slice(0) as Array<Individu>;
    this.listPalette = this.palettepresence.concat(
      this.paletteabsence
    ) as Array<PaletteDocument>;
  },
  methods: {
    log(msg:any){
      console.log(msg)
    },
    affichageEdition(id: number, enfant: Individu) {
      let autorisations: Array<Autorisations> = enfant.getListeAutorisations();
      let auto = autorisations.find(
        (item: Autorisations) =>
          item.getTypeautorisation_id() === id && item.isMobi()
      );
      if (typeof auto === "undefined") {
        return 0;
      } else {
        return auto.getAffichageedition();
      }
    },
    getRegimSrc(enfant: Individu) {
      if (
        enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Autre"
      )
        return "/assets/information/regime/REG_ALIM_AUTRE_LISTE_NOM.svg";
      if (
        enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans porc"
      )
        return "/assets/information/regime/REG_ALIM_SANS_PORC.svg";
      else if (
        enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans viande"
      )
        return "/assets/information/regime/REG_ALIM_SANS_VIANDE.svg";
      else if (
        enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Végétarien"
      )
        return "/assets/information/regime/REG_ALIM_VEGETARIEN.svg";
      else if (
        enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans gluten"
      )
        return "/assets/information/regime/REG_ALIM_SANS_GLUTEN.svg";
      else if (
        enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "PAI"
      )
        return "/assets/information/regime/REG_ALIM_PAI.svg";
      else if (
        enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans régime"
      )
        return "/assets/information/regime/REG_ALIM_DEFAUT_STANDARD.svg";
      else if (
        enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans poisson"
      )
        return "/assets/information/regime/REG_ALIM_SANS_POISSON.svg";
      else return "/assets/information/regime/REG_ALIM_AUTRE_LISTE_NOM.svg";
    },
    showListeUrgence(filtred: boolean) {
      this.$emit("show-liste-urgence", filtred);
    },
    pointerTemps(temps: TarifEventSchedulerActiviteDocument, enfant: Individu) {
      let pointage: Pointage = this.getPointage(temps, enfant) as Pointage;
      if (typeof pointage === "undefined" || !pointage.isIsInoe())
        this.$emit("pointerTAC", [temps, enfant]);
      else console.log("Pointage ", pointage.get_id());

    },
    getPointage(temps: TarifEventSchedulerActiviteDocument, enfant: Individu) {
     
      return this.pointageActif.find(
        (pointage: any) =>
          pointage.get_id() ===
            "pointageAN" +
              this.now +
              this.currentActiviteID +
              temps.getFriseElement_id() +
              enfant.getId() ||
          pointage.get_id() ===
            "pointageAN" +
              this.now +
              this.currentActiviteID +
              temps.getTempsTarif_id() +
              enfant.getId()
      );
    },
    pointageMasse(temps: TarifEventSchedulerActiviteDocument) {
      //if (this.tempsAccueilActif.length === 1) en sommeil
      this.$emit("pointageMasse", temps);
    },
 
    pointerSupplement(supplement: TarifActiviteDocument, enfant: Individu) {
      let suppActif: Supplement = this.getSupplementActif(
        supplement,
        enfant
      ) as Supplement;
      if (typeof suppActif === "undefined" || !suppActif.isIsInoe())
        this.$emit("pointerSupp", [supplement, enfant]);
      else console.log(suppActif);
    },
    supplementMasse(supplement: TarifActiviteDocument) {
      if (!supplement.isIsAuto()) this.$emit("supplementMasse", supplement);
    },
    getSupplementActif(supplement: TarifActiviteDocument, enfant: Individu) {
      return this.pointagesSupplements.find(
        (sup: any) =>
          sup.get_id() ===
          "supplementAN" +
            this.now +
            this.currentActiviteID +
            supplement.getId() +
            enfant.getId()
      );
    },
    isSupplementActif(
      supplement: TarifActiviteDocument,
      enfant: Individu
    ): boolean {
      return this.listSuppActifs.includes(
        "supplementAN" +
          this.now +
          this.currentActiviteID +
          +supplement.getId() +
          enfant.getId()
      );
    },
    selectImgSupplements(supplement: TarifActiviteDocument, enfant: Individu) {
      if (
        this.listSupplementsPrevi.some(
          (previ: any) =>
            enfant.getId() === previ.individu_id &&
            supplement.getId() === previ.supplement_id &&
            previ.checked
        )
      ) {
        return require(`@/assets/pointage/RESERVATION_GRILLE_POINTAGE.svg`);
      } else {
        return require(`@/assets/pointage/PAS_RESERVE_GRILLE_POINTAGE.svg`);
      }
    },
    selectImgSupplementsAuto(
      supplement: TarifActiviteDocument,
      enfant: Individu
    ) {
      if (
        supplement.getElementfrise_id().length > 1 &&
        supplement.getPlageetou() === "ET"
      ) {
        let conditionActif = supplement
          .getElementfrise_id()
          .every((friseId: number) =>
            this.pointageActif.some(
              (point: any) =>
                point.get_id() ===
                  "pointageAN" +
                    this.now +
                    this.currentActiviteID +
                    friseId +
                    enfant.getId() &&
                this.palettepresence.some(
                  (pal: any) => pal.getId() === point.getPaletteId()
                )
            )
          );
        if (conditionActif) {
          return require(`@/assets/pointage/PRESENCE_GRILLE_POINTAGE.svg`);
        } else {
          let conditionPrevi = supplement
            .getElementfrise_id()
            .every((friseId: number) =>
              this.pointagePrevi.some(
                (pointPrevi: any) =>
                  pointPrevi.elementfrise_id === friseId &&
                  pointPrevi.individu_id === enfant.getId()
              )
            );
          if (conditionPrevi) {
            return require(`@/assets/pointage/RESERVATION_GRILLE_POINTAGE.svg`);
          } else {
            return require(`@/assets/pointage/PAS_RESERVE_GRILLE_POINTAGE.svg`);
          }
        }
      } else {
        if (
          supplement.getElementfrise_id().length > 1 &&
          supplement.getPlageetou() === "OU"
        ) {
          let conditionActif = supplement
            .getElementfrise_id()
            .some((friseId: number) =>
              this.pointageActif.some(
                (point: any) =>
                  point.get_id() ===
                    "pointageAN" +
                      this.now +
                      this.currentActiviteID +
                      friseId +
                      enfant.getId() &&
                  this.palettepresence.some(
                    (pal: any) => pal.getId() === point.getPaletteId()
                  )
              )
            );
          if (conditionActif) {
            return require(`@/assets/pointage/PRESENCE_GRILLE_POINTAGE.svg`);
          } else {
            let conditionPrevi = supplement
              .getElementfrise_id()
              .some((friseId: number) =>
                this.pointagePrevi.some(
                  (pointPrevi: any) =>
                    pointPrevi.elementfrise_id === friseId &&
                    pointPrevi.individu_id === enfant.getId()
                )
              );
            if (conditionPrevi) {
              return require(`@/assets/pointage/RESERVATION_GRILLE_POINTAGE.svg`);
            } else {
              return require(`@/assets/pointage/PAS_RESERVE_GRILLE_POINTAGE.svg`);
            }
          }
        } else {
          if (
            this.pointageActif.some(
              (point: any) =>
                point.get_id() ===
                  "pointageAN" +
                    this.now +
                    this.currentActiviteID +
                    supplement.getElementfrise_id()[0] +
                    enfant.getId() &&
                this.palettepresence.some(
                  (pal: any) => pal.getId() === point.getPaletteId()
                )
            )
          ) {
            return require(`@/assets/pointage/PRESENCE_GRILLE_POINTAGE.svg`);
          } else {
            if (
              this.pointagePrevi.some(
                (pointPrevi: any) =>
                  pointPrevi.elementfrise_id ===
                    supplement.getElementfrise_id()[0] &&
                  pointPrevi.individu_id === enfant.getId()
              )
            ) {
              return require(`@/assets/pointage/RESERVATION_GRILLE_POINTAGE.svg`);
            } else {
              return require(`@/assets/pointage/PAS_RESERVE_GRILLE_POINTAGE.svg`);
            }
          }
        }
      }
    },
    isSupplementAutoInoe(supplement: TarifActiviteDocument, enfant: Individu) {
      if (
        supplement.getElementfrise_id().length > 1 &&
        supplement.getPlageetou() === "ET"
      ) {
        return supplement
          .getElementfrise_id()
          .every((friseId: number) =>
            this.pointageActif.some(
              (point: any) =>
                point.isIsInoe() &&
                point.get_id() ===
                  "pointageAN" +
                    this.now +
                    this.currentActiviteID +
                    friseId +
                    enfant.getId() &&
                this.palettepresence.some(
                  (pal: any) => pal.getId() === point.getPaletteId()
                )
            )
          );
      } else {
        if (
          supplement.getElementfrise_id().length > 1 &&
          supplement.getPlageetou() === "OU"
        ) {
          return supplement
            .getElementfrise_id()
            .some((friseId: number) =>
              this.pointageActif.some(
                (point: any) =>
                  point.isIsInoe() &&
                  point.get_id() ===
                    "pointageAN" +
                      this.now +
                      this.currentActiviteID +
                      friseId +
                      enfant.getId() &&
                  this.palettepresence.some(
                    (pal: any) => pal.getId() === point.getPaletteId()
                  )
              )
            );
        } else {
          return this.pointageActif.some(
            (point: any) =>
              point.isIsInoe() &&
              point.get_id() ===
                "pointageAN" +
                  this.now +
                  this.currentActiviteID +
                  supplement.getElementfrise_id()[0] +
                  enfant.getId() &&
              this.palettepresence.some(
                (pal: any) => pal.getId() === point.getPaletteId()
              )
          );
        }
      }
    },
   
    isSupplementInoe(
      supplement: TarifActiviteDocument,
      enfant: Individu
    ): boolean {
      let suppActif: Supplement = this.getSupplementActif(
        supplement,
        enfant
      ) as Supplement;
      return typeof suppActif !== "undefined" ? suppActif.isIsInoe() : false;
    },
  },
  watch: {
    pointageActif(newVal: Array<Pointage>, oldVal: Array<Pointage>) {
      console.log("pointageActif changed")
      // this.listActif = [];
      // this.listActif = Array.from(
      //   newVal.map((pointage: any) => pointage.get_id())
      // );
      // console.log(newVal.length)
      // this.listindividus.forEach(ind=> {
      //   const pointagesEnfant=newVal.filter((p:any)=>p.getIdIndividu()==ind.getId())
      //    ind.setListActif(pointagesEnfant)
      // }) 
      
    },
    pointagesSupplements(newVal: Array<Supplement>, oldVal: Array<Supplement>) {
      this.listSuppActifs = newVal.map((supplement: any) =>
        supplement.get_id()
      );
    },
    listenfants(newVal: Array<Individu>, oldVal: Array<Individu>) {
      console.log("list enfant changed")
      this.listindividus = newVal.slice(0);
    },
    currentDate(newVal: string, oldVal: string) {
      this.now = utils
        .getDateFromString(newVal, "YYYY-MM-DD")
        .format("YYYYMMDD");
    },
  },
});
